/**
 * Created by Alex Aguilar on 7/26/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('continentService', continentService);

    continentService.$inject = ['$http', 'CONFIG', 'messageService'];

    function continentService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/continents',
            service = {
                getContinents: getContinents
            };

        return service;

        function getContinents(){
            return $http.get(urlBase)
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.continents : [];
                }).catch(function(){
                    messageService.findAllError('');
                });
        }

    }
})();
